'use strict';

var chunk2NWFB3AL_js = require('../chunk-2NWFB3AL.js');
require('../chunk-Z6CB3LVR.js');
require('../chunk-HUKGHOBJ.js');
require('../chunk-S7FZ7BAB.js');
require('../chunk-M632V57T.js');
var r = require('react');
var m = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var r__default = /*#__PURE__*/_interopDefault(r);
var m__default = /*#__PURE__*/_interopDefault(m);

var a=m__default.default.div`
  width: ${({$withFixedWidth:i})=>i?"110px":"100%"};
`,x=({list:i=[],withFixedWidth:o=!0,onClick:p=()=>{},imgLoadingType:t="eager"})=>r__default.default.createElement(r__default.default.Fragment,null,(i||[]).map((d,n)=>r__default.default.createElement(a,{$withFixedWidth:o},r__default.default.createElement(chunk2NWFB3AL_js.a,{imgLoadingType:t,...d,idx:n,onClickHandler:p}))));

exports.ServiceWrapper = x;
